import axios from "axios";
// Relative, not the bare "constants" specifier — see customer-ledger.service.ts.
import { API_URL } from "../constants";
import { CustomerSettlementsResponse } from "types/CustomerSettlements";

export interface FetchSettlementsParams {
  kind?: string;
  /** Only settlements with an unallocated remainder (i.e. open advances). */
  openOnly?: boolean;
  page?: number;
  pageSize?: number;
  /** Attaches what each payment was spread over. */
  withAllocations?: boolean;
}

export const fetchSettlements = (
  companyId: string,
  customerId: string,
  { kind, openOnly, page, pageSize, withAllocations }: FetchSettlementsParams = {}
): Promise<CustomerSettlementsResponse> => {
  const url = `${API_URL}/${companyId}/customers/${customerId}/settlements`;
  const params: Record<string, string> = {};
  if (kind) params.kind = kind;
  if (openOnly) params.openOnly = "true";
  if (page) params.page = String(page);
  if (pageSize) params.pageSize = String(pageSize);
  if (withAllocations) params.withAllocations = "1";
  return axios.get(url, { params }).then((response) => response.data);
};
